// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fc5691c7","682":"1af01d37"}[chunkId] + ".chunk.js";
};